import React from 'react';
import { Box, Button, Typography, IconButton } from '@mui/material';
import { Delete, Category, EmojiEvents, Close } from '@mui/icons-material';

const BulkActionsBar = ({
  selectedCount,
  onDelete,
  onAssignCategories,
  onAssignContests,
  onClearSelection,
}) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#142C5C',
        borderRadius: '12px',
        padding: '12px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.25)',
        zIndex: 1000,
        animation: 'slideUp 0.3s ease-out',
        '@keyframes slideUp': {
          from: {
            opacity: 0,
            transform: 'translateX(-50%) translateY(20px)',
          },
          to: {
            opacity: 1,
            transform: 'translateX(-50%) translateY(0)',
          },
        },
      }}
    >
      <Typography
        sx={{
          color: 'white',
          fontWeight: 600,
          fontSize: '14px',
          whiteSpace: 'nowrap',
        }}
      >
        {selectedCount} selected
      </Typography>

      <Box sx={{ height: '24px', width: '1px', backgroundColor: 'rgba(255,255,255,0.3)' }} />

      <Button
        startIcon={<Category />}
        onClick={onAssignCategories}
        sx={{
          color: 'white',
          textTransform: 'none',
          fontSize: '13px',
          '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.1)',
          },
        }}
      >
        Categories
      </Button>

      <Button
        startIcon={<EmojiEvents />}
        onClick={onAssignContests}
        sx={{
          color: 'white',
          textTransform: 'none',
          fontSize: '13px',
          '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.1)',
          },
        }}
      >
        Contests
      </Button>

      <Button
        startIcon={<Delete />}
        onClick={onDelete}
        sx={{
          color: '#ff6b6b',
          textTransform: 'none',
          fontSize: '13px',
          '&:hover': {
            backgroundColor: 'rgba(255,107,107,0.1)',
          },
        }}
      >
        Delete
      </Button>

      <Box sx={{ height: '24px', width: '1px', backgroundColor: 'rgba(255,255,255,0.3)' }} />

      <IconButton
        onClick={onClearSelection}
        size="small"
        sx={{
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.1)',
          },
        }}
      >
        <Close fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default BulkActionsBar;
